import apiClient from "./apiClient";

// 회원 가입
export const addUser = async (userData) => {
  try {
    const response = await apiClient.post("/user/addUser", userData);
    return response.data; // "회원가입 성공" 문자열 반환
  } catch (error) {
    if (error.response) {
      // 서버가 400/500 반환
      throw error.response.data;
    } else {
      throw "서버 연결 실패";
    }
  }
};

// 회원 탈퇴
export const deleteUser = async () => {
  try {
    const res = await apiClient.delete("/user/delete");
    return res.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw "서버 연결 실패";
    }
  }
};

// 아이디 중복검사
export const checkUserId = async (userId) => {
  try {
    const response = await apiClient.get(`/user/check/userId`, {
      params: { userId: userId },
    });
    return response.data; // true 또는 false
  } catch (err) {
    console.error(err);
    return false;
  }
};

// 닉네임 중복검사
export const checkNickname = async (nickname) => {
  try {
    const response = await apiClient.get(`/user/check/nickname`, {
      params: { nickname: nickname },
    });
    return response.data; // true 또는 false
  } catch (err) {
    console.error(err);
    return false;
  }
};

// 로그인
export const loginUser = async (credentials) => {
  try {
    const response = await apiClient.post("/user/login/jwt", credentials);

    // JWT 저장
    localStorage.setItem("accessToken", response.data.accessToken);
    localStorage.setItem("userId", response.data.user.userId);

    localStorage.setItem("snsType", "normal");

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw "서버 연결 실패";
    }
  }
};

// 카카오 로그인
export const kakaoLoginWithProfile = async (kakaoId, nickname) => {
  try {
    const response = await apiClient.post("/user/login/kakao", {
      kakaoId,
      nickname,
    });

    localStorage.setItem("snsType", "kakao");

    return response.data;
  } catch (err) {
    console.error("카카오 로그인 실패:", err);
    throw err;
  }
};

// 구글 로그인
export const googleLoginWithProfile = async (googleId, nickname) => {
  try {
    const res = await apiClient.post("/user/login/google", {
      googleId,
      nickname,
    });

    localStorage.setItem("snsType", "google");

    return res.data;
  } catch (error) {
    console.error("구글 로그인 실패:", error);
    throw error;
  }
};

// 회원정보 수정
export const updateUser = async (userData) => {
  const res = await apiClient.post("/user/update", userData, {
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res.data;
};

// 비밀번호 변경 (JWT 기준)
export const changePassword = async ({
  currentPassword,
  newPassword,
}) => {
  const res = await apiClient.post(
    "/user/password",
    {
      currentPassword,
      newPassword,
    },
    {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return res.data;
};

// 성별 업데이트 (sns 로그인한 사용자 기준으로 gender만 변경)
export const updateGender = async (gender) => {
  try {
    const res = await apiClient.post(
      "/user/gender", // 백엔드에서 현재 로그인 사용자 gender 업데이트하도록 구현
      { gender },
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("성별 업데이트 실패:", error);
    if (error.response) {
      throw error.response.data;
    } else {
      throw "서버 연결 실패";
    }
  }
};
